export const translations = {
    'PTBR': {
        login: 'Entrar',
        password: 'Senha',
        signup: 'Cadastrar',
        forgotPassword: 'Esqueceu sua senha?',
        stillDeveloping: 'Ainda em desenvolvimento',
        error: 'Houve um erro, por favor tente novamente'
    },
    'EN': {
        login: 'Login',
        password: 'Password',
        signup: 'Sign Up',
        forgotPassword: 'Forgot your password?',
        stillDeveloping: 'Still in development',
        error: 'There was an error, please try again'
    }
}

export type LanguageKeys = keyof typeof translations;